export const RecipesDrawer = () => <div>Recipes Drawer</div>;
